import { render, staticRenderFns } from "./lifangti.vue?vue&type=template&id=7ba607f5&"
import script from "./lifangti.vue?vue&type=script&lang=js&"
export * from "./lifangti.vue?vue&type=script&lang=js&"
import style0 from "./lifangti.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports